
export const routerM = [{
    path: '/',
    redirect: '',
    component: () =>
      import('../../views/Layout/MainMobileLayout.vue'),
      children: [{
        path: '',
        name: 'mhome',
        component: () =>
          import('../../views/Mobile/MAbout.vue'),
          hidden: true,
        meta: {
          nav: 'home'
        }
      },
      {
        path: "/About",
        name: "about",
        component: () => import("../../views/Mobile/MAbout.vue"),
        meta: {
          nav: 'about'
        }
      },
      {
        path: "/Product/:id",
        name: "product",
        component: () => import("../../views/Mobile/MProduct.vue"),
        meta: {
          nav: 'product'
        }
      },
      {
        path: "/ProductDetail/:id",
        name: "productdetail",
        component: () => import("../../views/Mobile/MProductDetail.vue"),
        meta: {
          nav: 'product'
        }
      },
      {
        path: "/Esg",
        name: "esg",
        component: () => import("../../views/Mobile/MEsg.vue"),
        meta: {
          nav: 'esg'
        }
      },
      {
        path: "/News",
        name: "news",
        component: () => import("../../views/Mobile/MNews.vue"),
        meta: {
          nav: 'news'
        }
      },
      {
        path: "/NewsDetail/:id",
        name: "newsdetail",
        component: () => import("../../views/Mobile/MNewsDetail.vue"),
        meta: {
          nav: 'news'
        }
      },
      {
        path: "/Join",
        name: "join",
        component: () => import("../../views/Mobile/MJoin.vue"),
        meta: {
          nav: 'join'
        }
      },
      {
        path: "/JoinDetail/:id",
        name: "joindetail",
        component: () => import("../../views/Mobile/MJoinDetail.vue"),
        meta: {
          nav: 'join'
        }
      },
      {
        path: "/Contact",
        name: "contact",
        component: () => import("../../views/Mobile/MContact.vue"),
        meta: {
          nav: 'contact'
        }
      },
    ]
  },
  
  ]
  
  
 